import React from "react";
import { Text, View, SafeAreaView, Dimensions, ScrollView, Linking, TouchableOpacity, Platform } from "react-native";
import { FontAwesome6 } from '@expo/vector-icons';
import { useTheme } from './ThemeContext';

const { width: screenWidth, height: screenHeight } = Dimensions.get("window");
const isSmallScreen = screenWidth < 375;
const isLargeScreen = screenWidth >= 390;
const scaleFactor = isSmallScreen ? 0.85 : (isLargeScreen ? 1.0 : 0.95);

export default function Support() {
  const { themeValues } = useTheme();

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: themeValues.background,
      }}
    >
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: themeValues.background,
        }}
        contentContainerStyle={{
          flexGrow: 1,
          padding: 20 * scaleFactor,
          paddingTop: Platform.OS === 'ios' ? (isLargeScreen ? 120 : 100) : 60,
        }}
      >
        <View
          style={{
            transform: [{ scale: scaleFactor }]
          }}
        >
          <Text
            style={{
              color: themeValues.primary,
              fontSize: (Platform.OS === 'web' ? 36 : 20) * scaleFactor,
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: 20,
            }}
          >
            Support
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 18 : 16) * scaleFactor,
              textAlign: "center",
              lineHeight: (Platform.OS === 'web' ? 24 : 20) * scaleFactor,
              marginBottom: 30,
            }}
          >
            We're here to help you get the most out of MeditRate
          </Text>

          <View style={{ marginBottom: 30 }}>
            <Text
              style={{
                color: themeValues.primary,
                fontSize: (Platform.OS === 'web' ? 20 : 18) * scaleFactor,
                fontWeight: "bold",
                marginBottom: 15,
              }}
            >
              Contact Support
            </Text>

            <TouchableOpacity
              style={{
                backgroundColor: themeValues.secondary,
                padding: 15 * scaleFactor,
                borderRadius: 10,
                marginBottom: 15,
                flexDirection: "row",
                alignItems: "center",
              }}
              onPress={() => Linking.openURL('mailto:meditrateapp@gmail.com')}
            >
              <FontAwesome6 name="envelope" size={20 * scaleFactor} color={themeValues.primary} style={{ marginRight: 15 }} />
              <View>
                <Text style={{ color: themeValues.text, fontSize: 16 * scaleFactor, fontWeight: "bold" }}>
                  Email Support
                </Text>
                <Text style={{ color: themeValues.muted, fontSize: 14 * scaleFactor }}>
                  meditrateapp@gmail.com
                </Text>
                <Text style={{ color: themeValues.muted, fontSize: 12 * scaleFactor }}>
                  Response within 24-48 hours
                </Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                backgroundColor: themeValues.secondary,
                padding: 15 * scaleFactor,
                borderRadius: 10,
                marginBottom: 15,
                flexDirection: "row",
                alignItems: "center",
              }}
              onPress={() => Linking.openURL('https://www.meditrate.com/support')}
            >
              <FontAwesome6 name="globe" size={20 * scaleFactor} color={themeValues.primary} style={{ marginRight: 15 }} />
              <View>
                <Text style={{ color: themeValues.text, fontSize: 16 * scaleFactor, fontWeight: "bold" }}>
                  Web Support
                </Text>
                <Text style={{ color: themeValues.muted, fontSize: 14 * scaleFactor }}>
                  www.meditrate.com/support
                </Text>
                <Text style={{ color: themeValues.muted, fontSize: 12 * scaleFactor }}>
                  FAQs and guides
                </Text>
              </View>
            </TouchableOpacity>
          </View>

          <View style={{ marginBottom: 30 }}>
            <Text
              style={{
                color: themeValues.primary,
                fontSize: (Platform.OS === 'web' ? 20 : 18) * scaleFactor,
                fontWeight: "bold",
                marginBottom: 15,
              }}
            >
              Frequently Asked Questions
            </Text>

            <View style={{ marginBottom: 20 }}>
              <Text style={{ color: themeValues.text, fontSize: 16 * scaleFactor, fontWeight: "bold", marginBottom: 5 }}>
                How does heart entrainment work?
              </Text>
              <Text style={{ color: themeValues.text, fontSize: 14 * scaleFactor, lineHeight: 18 * scaleFactor }}>
                Heart entrainment is a natural phenomenon where your heartbeat synchronizes with external rhythmic sounds. MeditRate uses scientifically-designed sounds to guide your heart to your desired rhythm.
              </Text>
            </View>

            <View style={{ marginBottom: 20 }}>
              <Text style={{ color: themeValues.text, fontSize: 16 * scaleFactor, fontWeight: "bold", marginBottom: 5 }}>
                Is MeditRate safe to use?
              </Text>
              <Text style={{ color: themeValues.text, fontSize: 14 * scaleFactor, lineHeight: 18 * scaleFactor }}>
                Yes, MeditRate uses only audio guidance and does not interfere with your heart's natural functioning. However, consult your doctor if you have heart conditions.
              </Text>
            </View>

            <View style={{ marginBottom: 20 }}>
              <Text style={{ color: themeValues.text, fontSize: 16 * scaleFactor, fontWeight: "bold", marginBottom: 5 }}>
                Can I use MeditRate with headphones?
              </Text>
              <Text style={{ color: themeValues.text, fontSize: 14 * scaleFactor, lineHeight: 18 * scaleFactor }}>
                Yes, headphones are recommended for the best experience and clearer sound quality.
              </Text>
            </View>

            <View style={{ marginBottom: 20 }}>
              <Text style={{ color: themeValues.text, fontSize: 16 * scaleFactor, fontWeight: "bold", marginBottom: 5 }}>
                Does MeditRate collect my personal data?
              </Text>
              <Text style={{ color: themeValues.text, fontSize: 14 * scaleFactor, lineHeight: 18 * scaleFactor }}>
                No, MeditRate operates completely offline and does not collect or transmit any personal information.
              </Text>
            </View>

            <View style={{ marginBottom: 20 }}>
              <Text style={{ color: themeValues.text, fontSize: 16 * scaleFactor, fontWeight: "bold", marginBottom: 5 }}>
                What devices are supported?
              </Text>
              <Text style={{ color: themeValues.text, fontSize: 14 * scaleFactor, lineHeight: 18 * scaleFactor }}>
                MeditRate supports iPhone, iPad, and web browsers running modern versions.
              </Text>
            </View>
          </View>

          <View style={{ marginBottom: 30 }}>
            <Text
              style={{
                color: themeValues.primary,
                fontSize: (Platform.OS === 'web' ? 20 : 18) * scaleFactor,
                fontWeight: "bold",
                marginBottom: 15,
              }}
            >
              Technical Requirements
            </Text>

            <Text style={{ color: themeValues.text, fontSize: 14 * scaleFactor, lineHeight: 18 * scaleFactor }}>
              • iOS Version: 14.0 or later
              {"\n"}• Device: iPhone, iPad
              {"\n"}• Storage: 50MB
              {"\n"}• Internet: Not required for core functionality
            </Text>
          </View>

          <View style={{ marginBottom: 30 }}>
            <Text
              style={{
                color: themeValues.primary,
                fontSize: (Platform.OS === 'web' ? 20 : 18) * scaleFactor,
                fontWeight: "bold",
                marginBottom: 15,
              }}
            >
              Feedback & Bug Reports
            </Text>

            <TouchableOpacity
              style={{
                backgroundColor: themeValues.secondary,
                padding: 15 * scaleFactor,
                borderRadius: 10,
                marginBottom: 15,
                flexDirection: "row",
                alignItems: "center",
              }}
              onPress={() => Linking.openURL('mailto:meditrateapp@gmail.com')}
            >
              <FontAwesome6 name="comment" size={20 * scaleFactor} color={themeValues.primary} style={{ marginRight: 15 }} />
              <View>
                <Text style={{ color: themeValues.text, fontSize: 16 * scaleFactor, fontWeight: "bold" }}>
                  Send Feedback
                </Text>
                <Text style={{ color: themeValues.muted, fontSize: 14 * scaleFactor }}>
                  meditrateapp@gmail.com
                </Text>
                <Text style={{ color: themeValues.muted, fontSize: 12 * scaleFactor }}>
                  Help us improve MeditRate
                </Text>
              </View>
            </TouchableOpacity>
          </View>

          <View style={{ alignItems: "center", marginTop: 30 }}>
            <Text
              style={{
                color: themeValues.muted,
                fontSize: 12,
                textAlign: "center",
              }}
            >
              App Version: 1.0.6
              {"\n"}© 2026 MeditRate. All rights reserved.
            </Text>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}
